// Constants
export const ARTICLES_API_URL =
  "https://gist.githubusercontent.com/cmnstmntmn/a96aeb7875ff582cee6ee18000a2077a/raw/8e61684f73c94b3202824564d8792f8ad03273a4/articles.json";

export const NETWORK_REQUEST_STATES = {
  NOOP: "NOOP",
  LOADING: "LOADING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
};
